import PortalApp from './features/portal/PortalApp';

export default function App() {
  return <PortalApp />;
}
